import { Modal } from 'almanac-ui/Modal'
import { DeleteWorkflowConfirmationModalProps } from './Types'

const DeleteWorkflowConfirmationModal = ({ onConfirm, onCancel }: DeleteWorkflowConfirmationModalProps) => {
  return (
    <Modal.Root>
      <Modal.Header title="Delete Workflow" />
      <Modal.Content>
        <p>
          The status will be removed from all the documents inside this folder, and all the board views created by any
          user for this folder will be deleted.
        </p>
        <p>Are you sure you want to continue?</p>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton size="lg" variant="tertiary" onPress={onCancel}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton size="lg" onPress={onConfirm}>
            Delete
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}

export { DeleteWorkflowConfirmationModal }
